import { createBrowserRouter } from "react-router";

import { createShellLoader } from "./loader";
import { ShellErrorBoundary } from "./ShellErrorBoundary";
import { TinkertoyShell } from "./TinkertoyShell";
import type { ShellConfig } from "./types";

/**
 * Creates the React Router instance for the Tinkertoy shell.
 *
 * A single catch-all route delegates all routing decisions to the server.
 * The loader fetches view data for whatever path the browser is on;
 * React Router handles navigation detection, history, back/forward,
 * and scroll restoration.
 *
 * Only `apiBaseUrl` is threaded into the loader — the `moduleLoader` is
 * provided to components via `InternalTinkertoyProvider` / `useModuleLoader`
 * so React Router (which builds the router synchronously) does not need
 * to know about it.
 */
export function createShellRouter(config: ShellConfig) {
  return createBrowserRouter([
    {
      path: "*",
      loader: createShellLoader({ apiBaseUrl: config.apiBaseUrl }),
      element: <TinkertoyShell />,
      errorElement: <ShellErrorBoundary />,
    },
  ]);
}
